<template>
<div class="chapter">
<div class="inner_page">
<p class="fm01"><a id="page_2"></a><span class="bold"><span class="blue">Front Cover:</span></span> <em class="italic">An unidentified power car powers through Defford on 28 September 2003 whilst leading the final HST-operated Penzance-Glasgow Central service</em>.</p>
<p class="fm02"><span class="bold"><span class="blue">Rear Cover:</span></span> <em class="italic">Between 1997 and 2007 the main West Coast Main Line route was shared by both Virgin Cross Country and Virgin West Coast franchises as noted on 26 January 2005 when a Class 220 ‘Voyager’ trainset heading north out of Preston was viewed from St Michael’s church tower when passing a southbound Class 390 ‘Pendolino’ trainset approaching Preston station</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm01.vue?685107de